import { environment as baseEnvironment } from './environment.base';
import { environment as prodEnvironment } from './environment.prod';
import { environment as localEnvironment } from './environment.local';
import { Message } from 'src/app/interfaces/Message';
import { Mail } from 'src/app/interfaces/Mail';

export interface Environment {
    production: boolean;
    WEATHER_API_URL: string;
    all_mails: Mail[];
    all_messages: Message[];
    gaToken: string|null;
}

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const isProd = window.location.host.includes('lvb-mediaexperience.netlify.app') || window.location.host.includes('lvbmediaexperience.online');

const envEnvironment = isProd ? prodEnvironment : localEnvironment;

export const environment: Environment = {
    ...baseEnvironment,
    ...envEnvironment
};
